<template>
  <v-dialog :value="value" persistent max-width="800px">
    <div class="modal-container">
      <div class="d-flex w-full justify-end">
        <v-btn icon @click="$emit('input', false)" class="-mt-12 -mr-12">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <img loading="lazy" src="https://storage.googleapis.com/keybe/files/bluebird/billing/credit-card.svg"
           alt="credit card" class="mb-4">
      <img src="https://storage.googleapis.com/keybe/files/bluebird/billing/success.svg" alt="success" class="mb-8">
      <strong>¡Tu tarjeta de crédito a sido cargada exitosamente!</strong>
      <span>Sigue disfrutando de todo lo que Keybe tienen para tu negocio</span>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'SuccessDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #FFFFFF;
  padding: 4rem
}
</style>
